import { styled } from '@mui/material';
import SwipeableViews from 'react-swipeable-views';

import { shouldForwardProps } from '../../utils/mui-styled.utils';
import { CARD_MAX_WIDTH } from '../../utils/sizes.utils';

interface CardWrapperProps {
	active?: boolean;
}

export const StyledCarouselComponentContainer = styled('div')({
	width: '100%',
});

export const StyledCarouselComponentSwipeableViews = styled(SwipeableViews)(
	({
		theme: {
			palette: { sizes },
		},
	}) => ({
		width: '100%',
		overflowX: 'hidden',
		padding: `0 ${sizes.size_1}%`,
		boxSizing: 'border-box',
		'& > div': {
			overflowX: 'visible !important' as any,
			maxWidth: CARD_MAX_WIDTH,
			margin: '0 auto',
			'& > div': {
				padding: sizes.sizeHalf,
				display: 'flex',
				'@media (min-width: 624px)': {
					padding: `${sizes.sizeHalf}px ${sizes.size_1}px`,
				},
			},
		},
	}),
);

export const StyledCarouselComponentCardWrapper = styled('div', {
	shouldForwardProp: shouldForwardProps(['active']),
})<CardWrapperProps>(
	({
		theme: {
			palette: {
				colorScheme: { colorVariables },
			},
		},
		active,
	}) => ({
		flexGrow: 1,
		width: '100%',
		cursor: active ? 'default' : 'pointer',
		...(active && {
			'& > div': {
				border: `1px solid ${colorVariables.colorCaption}`,
			},
		}),
	}),
);
